import { PendingItemType } from '@appTypes/enums';
import { advancementTypes, historyItemsTypes } from '@shared/constants';

export { historyItemsTypes };

/** Final store path is `advancements.pendingItems` */
export const moduleName = 'pendingItems';

export const filterPanels = Object.freeze({
  ADVANCEMENT_TYPES: 'advancementTypes',
  ACTIVITY_TYPES: 'activityTypes',
  SORTER: 'sorter',
});

export enum PendingItemsTabs {
  RANKS = 'ranks',
  MERIT_BADGES = 'meritBadges',
  ACTIVITIES = 'activities',
  ADVENTURES = 'adventures',
  AWARDS = 'awards',
  SS_ELECTIVES = 'ssElectives',
  LEADERSHIP_POSITIONS = 'leadershipPositions',
  REQUIREMENTS = 'requirements',
}

export const advancementTypeToTabsMap = Object.freeze({
  [advancementTypes.MERIT_BADGES]: PendingItemsTabs.MERIT_BADGES,
  [advancementTypes.RANKS]: PendingItemsTabs.RANKS,
  [advancementTypes.AWARDS]: PendingItemsTabs.AWARDS,
  [advancementTypes.ADVENTURES]: PendingItemsTabs.ADVENTURES,
  [advancementTypes.SSELECTIVES]: PendingItemsTabs.SS_ELECTIVES,
});

export const AdvancementsTabsNames = Object.freeze({
  BULK_ENTRY: 'bulkEntry',
  TO_APPROVE: 'toApprove',
  TO_PURCHASE: 'toPurchase',
  TO_AWARD: 'toAward',
  AWARDED: 'awarded',
  HISTORY: 'history',
});
export type AdvancementsTabsType =
  (typeof AdvancementsTabsNames)[keyof typeof AdvancementsTabsNames];

export const advancementTypeResponse = Object.freeze({
  ADVENTURE: 'Adventure',
  RANK: 'Rank',
  MERIT_BADGE: 'MeritBadge',
  AWARD: 'Award',
});

export const AdvancementsTabs = Object.freeze([
  AdvancementsTabsNames.BULK_ENTRY,
  AdvancementsTabsNames.TO_APPROVE,
  AdvancementsTabsNames.TO_PURCHASE,
  AdvancementsTabsNames.TO_AWARD,
  AdvancementsTabsNames.AWARDED,
  AdvancementsTabsNames.HISTORY,
]);

export const tabsToAdvancementTypeMap = {
  [PendingItemsTabs.ADVENTURES]: PendingItemType.ADVENTURES,
  [PendingItemsTabs.AWARDS]: PendingItemType.AWARDS,
  [PendingItemsTabs.MERIT_BADGES]: PendingItemType.MERIT_BADGES,
  [PendingItemsTabs.ACTIVITIES]: PendingItemType.ACTIVITIES,
  [PendingItemsTabs.RANKS]: PendingItemType.RANKS,
  // [PendingItemsTabs.SS_ELECTIVES]: PendingItemType.SSELECTIVES,
} as const;
